import { JobDescription } from "../Beneficiary/job-description";
import { CompanyContactType } from "./company-contact-type";
import { FederalRegistration } from "./federal-registration";
import { SocialNumber } from "./social-number";

export class CompanyContact {
  private companyContactKey: string;
  private companyFiscalNumber: string;
  private name: string;
  private unit: string;
  private jobDescription: JobDescription;
  private telephone: string;
  private mobile: string;
  private email: string;
  private area: string;
  private hasLegalRepresentativeInfo: boolean;
  private additionalInformation: string;
  private federalRegistration: FederalRegistration;
  private socialNumber: SocialNumber;

  setCompanyContactKey(value: string): void {
    this.companyContactKey = value;
  }

  getCompanyContactKey(): string {
    return this.companyContactKey;
  }

  setCompanyFiscalNumber(value: string): void {
    this.companyFiscalNumber = value;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setUnit(value: string): void {
    this.unit = value;
  }

  getUnit(): string {
    return this.unit;
  }

  setJobDescription(value: JobDescription): void {
    this.jobDescription = value;
  }

  getJobDescription(): JobDescription {
    return this.jobDescription;
  }

  setTelephone(value: string): void {
    this.telephone = value;
  }

  getTelephone(): string {
    return this.telephone;
  }

  setMobile(value: string): void {
    this.mobile = value;
  }

  getMobile(): string {
    return this.mobile;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  getEmail(): string {
    return this.email;
  }

  setArea(value: string): void {
    this.area = value;
  }

  getArea(): string {
    return this.area;
  }

  setHasLegalRepresentativeInfo(value: boolean): void {
    this.hasLegalRepresentativeInfo = value;
  }

  getHasLegalRepresentativeInfo(): boolean {
    return this.hasLegalRepresentativeInfo;
  }

  setAdditionalInformation(value: string): void {
    this.additionalInformation = value;
  }

  getAdditionalInformation(): string {
    return this.additionalInformation;
  }

  setFederalRegistration(federalRegistration: FederalRegistration): void {
    this.federalRegistration = federalRegistration;
  }

  getFederalRegistration(): string {
    if (this.federalRegistration === undefined || this.federalRegistration === null) {
      return "";
    } else {
      return this.federalRegistration.getFederalRegistration();
    }
  }

  setSocialNumber(socialNumber: SocialNumber): void {
    this.socialNumber = socialNumber;
  }

  getSocialNumber(): string {
    if (this.socialNumber === undefined || this.socialNumber === null) {
      return "";
    } else {
      return this.socialNumber.getSocialNumber();
    }
  }
}
